// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-send {
  height: 21px;
  width: 32px;
}
.chat-send button {
  cursor: pointer;
  border-radius: 4px;
  height: 21px;
  display: flex;
  width: 32px;
}
.chat-send button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.chat-send img {
  width: 24px;
  height: 15px;
  margin: auto;
  opacity: 0.5;
  cursor: pointer;
  transition: all 0.2s ease;
}
@media (prefers-reduced-motion: reduce) {
  .chat-send img {
    transition: none;
  }
}
.chat-send img:hover {
  opacity: 1;
}
.chat-send img:active {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/constructorComponents/chat/sendButton/styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;AACF;AAAE;EACE,eAAA;EACA,kBAAA;EAEA,YAAA;EACA,aAAA;EACA,WAAA;AACJ;AAJI;EAAkB,oCAAA;EAAsC,mBAAA;AAQ5D;AAHG;EAEC,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AAIJ;AAVI;EADD;IAC2C,gBAAA;EAc5C;AACF;AARI;EACE,UAAA;AAUN;AARI;EACE,UAAA;AAUN","sourcesContent":[".chat-send {\r\n  height: 21px;\r\n  width: 32px;\r\n  button {\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\r\n    height: 21px;\r\n    display: flex;\r\n    width: 32px;\r\n  }\r\n   img {\r\n    @media (prefers-reduced-motion: reduce) { transition: none; }\r\n    width: 24px;\r\n    height: 15px;\r\n    margin: auto;\r\n    opacity: 0.5;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    &:hover {\r\n      opacity: 1;\r\n    }\r\n    &:active {\r\n      opacity: 1;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
